import { render, staticRenderFns } from "./interactData.vue?vue&type=template&id=772d16db&scoped=true&"
import script from "./interactData.vue?vue&type=script&lang=js&"
export * from "./interactData.vue?vue&type=script&lang=js&"
import style0 from "./interactData.vue?vue&type=style&index=0&id=772d16db&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772d16db",
  null
  
)

export default component.exports